module.exports = __webpack_public_path__ + "img/icon-tag.1494132d.svg";